import React, { useState, useEffect, useCallback } from "react";
import ReportsPickerCard from "./ReportsPickerCard";
import {pipe, prop, sortBy, toUpper} from "ramda";

const OrganizationReportsPickerCard = ({
  organizations = [],
  onOrganizationChange,
  ...props
}) => {
  const organizationNameSort = sortBy(pipe(prop("name"), toUpper));
  const [selectedOrganization, setSelectedOrganization] = useState("");

  const handleOrganizationChange = useCallback(
    (value) => {
      setSelectedOrganization(value);
      if (onOrganizationChange) {
        onOrganizationChange(value);
      }
    },
    [onOrganizationChange]
  );

  useEffect(() => {
    if (organizations.length > 0) {
      handleOrganizationChange(organizations[0].id);
    }
  }, [organizations, handleOrganizationChange]);

  return (
    <ReportsPickerCard
      label="ORGANIZATION"
      values={organizationNameSort(organizations)}
      selectedValue={selectedOrganization}
      onValueChange={handleOrganizationChange}
    >
      {props.children}
    </ReportsPickerCard>
  );
};

export default OrganizationReportsPickerCard;
